import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
/**
 * Optimizely sdk client initialized to start making evaluations / tracking events
 */
import { createInstance } from '@optimizely/react-sdk';
import env from '@upgrade/ui-utils/env';
import createDataFetcher from '../api';
var clientPromise = null;

/**
 * Fetches the optimizely data file and returns an instance of ReactSDKClient.
 * @param {function} getDefaults
 * @returns {Promise<import('@optimizely/react-sdk').ReactSDKClient>}
 */
export var initialize = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(getDefaults) {
    var dataFetcher, datafile, logLevel, client;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          dataFetcher = createDataFetcher(getDefaults);
          _context.next = 3;
          return dataFetcher();
        case 3:
          datafile = _context.sent;
          logLevel = env.REACT_APP_OPTIMIZELY_LOG_LEVEL || 'disabled';
          client = createInstance({
            datafile: datafile,
            logLevel: logLevel
          });
          return _context.abrupt("return", client);
        case 7:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function initialize(_x) {
    return _ref.apply(this, arguments);
  };
}();

/**
 * Initializes and caches a ReactSDKClient.
 * @returns {Promise<import('@optimizely/react-sdk').ReactSDKClient>}
 */
export default (function () {
  // USAGE: do not cache the client because we could decide to apply dynamic updates to the SDK and that will create
  // different instances of the client over time.
  if (!clientPromise) {
    clientPromise = initialize();
  }
  return clientPromise;
});